module.exports = __webpack_public_path__ + "static/media/comment.4d6d4fdc.svg";